module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp1_0.16ca3fc5.png";